module.exports = __webpack_public_path__ + "static/img/stamp_09.0120abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/stamp_09.jpg
// module id = KQOL
// module chunks = 1